/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_1e2f7dc7"]'><div :class='["modal-two-horizontal-btn2-demo"]'><cube-modal ref="__mpx_ref_modal__" title="我是标题~" content="我是正文我是正文我是正文我是正文我是正文我是正文" direction="horizontal" confirm-btn="确认按钮" cancel-btn="取消按钮" :mask-closable="(true)" :no-built-in-btns="(true)" @confirm='(e)=>__invoke(e, [["onConfirm"]])' @cancel='(e)=>__invoke(e, [["onCancel"]])'><div slot="footer"><cube-button-group direction="horizontal"><cube-button @_click="onCancel" :class='["cancel-btn"]'>取消按钮</cube-button><cube-button light @_click="onConfirm" :class='["confirm-btn"]'>确认按钮</cube-button></cube-button-group></div></cube-modal><cube-button @_click="onTap">modal-水平两个按钮（弱引导）</cube-button></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_1e2f7dc7"}'>
.modal-two-horizontal-btn2-demo
  .cancel-btn
    margin-right 7px
  .confirm-btn, .cancel-btn
    flex 1
    margin-top 30px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_1e2f7dc7"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_1e2f7dc7"}
  /** script content **/
  require("./modal-two-horizontal-btn2.mpx.js?isComponent&outputPath=components%2Fmodal-two-horizontal-btn21e2f7dc7%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./modal-two-horizontal-btn2.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fmodal-two-horizontal-btn21e2f7dc7%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_1e2f7dc7"],
    ctorType: "component",
    outputPath: "components/modal-two-horizontal-btn21e2f7dc7/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/modal/index.mpx?isComponent&outputPath=components%2Findex317b3b4c%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-button-group':getComponent(require("../../../packages/mpx-cube-ui/src/components/button-group/index.mpx?isComponent&outputPath=components%2Findexb32f512a%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>